module.exports = __webpack_public_path__ + "img/macbook.15de5260.png";